import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useService } from '../providers/ServiceProvider';
import { Domain } from '@analyzer/client';

export function useDomainListQuery(projectId: string, queryParams?: { limit?: number; offset?: number }) {
  const client = useService();
  return useQuery<Domain[], Error>(
    ['domain-list', projectId, queryParams],
    () => client.domainList(projectId, queryParams),
    {
      keepPreviousData: true
    }
  );
}

export function useDomainReadQuery(projectId: string, domainId: string | null) {
  const client = useService();
  return useQuery<Domain, Error>({
    queryKey: ['domain-read', domainId],
    queryFn: () => client.domainRead(projectId, domainId!),
    enabled: !!domainId
  });
}

export function useDomainDestroyMutation(projectId: string) {
  const client = useService();
  const queryClient = useQueryClient();

  return useMutation<boolean, Error, { domainId: string }>({
    mutationFn: ({ domainId }) => client.domainDestroy(projectId, domainId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['domain-list', projectId] })
  });
}

export function useDomainCreateMutation(projectId: string) {
  const client = useService();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (name: string) => client.domainCreate(projectId, { name }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['domain-list', projectId] })
  });
}
